import React from 'react';
import { Button, Card, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AcessoNegado = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 720, margin: '40px auto' }}>
      <Card title="Acesso negado">
        <p>Você não tem permissão para acessar esta página.</p>
        <p>Se isso estiver incorreto, entre em contato com a escola ou tente entrar novamente.</p>
        <Space>
          <Button onClick={() => navigate(-1)}>Voltar</Button>
          <Button type="primary" onClick={logout}>Entrar novamente</Button>
        </Space>
      </Card>
    </div>
  );
};

export default AcessoNegado;
